/**
 * Configuration du produit Token - Système de personnalisation de vélo
 * 
 * Ce fichier gère toutes les interactions utilisateur pour la configuration
 * d'un vélo personnalisé, incluant la sélection des options, le calcul des prix
 * et la gestion du panier.
 */

// Attendre que le DOM soit chargé avant d'initialiser
document.addEventListener('DOMContentLoaded', function() {
  
  // Récupération des éléments DOM principaux
  const elements = {
    variantSelector: document.getElementById('product-variant-selector'),
    variantOptions: document.querySelectorAll('.variant-option'),
    accessoryCheckboxes: document.querySelectorAll('.accessory-checkbox'),
    summaryItems: document.getElementById('summary-items'),
    summaryTotalPrice: document.querySelector('.summary-total-price'),
    mobileSummaryItems: document.getElementById('mobile-summary-items'),
    mobileSummaryTotalPrice: document.querySelector('.mobile-summary-total-price'),
    paymentButtonPrice: document.querySelector('.summary-total-price'),
    buyNowButton: document.getElementById('buy-now-button'),
    variantInput: document.querySelector('#product-form input[name="id"]')
  };
  
  // Initialiser l'interface utilisateur
  initAccordion();
  initMobileSummaryToggle();
  
  /**
   * Fonction pour mettre à jour le sélecteur de variante Shopify
   * Cette fonction synchronise les sélections visuelles avec le sélecteur caché de Shopify
   */
  function updateVariantSelector() {
    const selectedOptions = [];
    
    // Récupérer toutes les options sélectionnées
    document.querySelectorAll('.product-variants').forEach(function(variantSection) {
      const selectedOption = variantSection.querySelector('.variant-option.selected');
      if (selectedOption) {
        const position = parseInt(selectedOption.dataset.optionPosition);
        const value = selectedOption.dataset.value;
        selectedOptions[position - 1] = value;
      }
    });

    // Trouver la variante correspondante dans le sélecteur Shopify
    if (selectedOptions.length > 0 && !selectedOptions.includes(undefined)) {
      for (let i = 0; i < elements.variantSelector.options.length; i++) {
        const option = elements.variantSelector.options[i];
        const variantTitle = option.text.split(' - ')[0];
        const variantParts = variantTitle.split(' / ');
        
        let matches = true;
        for (let j = 0; j < selectedOptions.length; j++) {
          if (variantParts[j] !== selectedOptions[j]) {
            matches = false;
            break;
          }
        }
        
        if (matches) {
          elements.variantSelector.selectedIndex = i;
          // Mettre à jour l'input caché avec l'ID de la variante
          if (elements.variantInput) {
            elements.variantInput.value = option.value;
          } else {
            console.warn("L'input de variante n'a pas été trouvé dans le formulaire");
          }
          break;
        }
      }
    }
  }
  
  /**
   * Met à jour les images superposées en fonction des options sélectionnées
   */
  function updateOverlayImages() {
    // Récupérer toutes les options sélectionnées
    const selectedOptions = {};
    document.querySelectorAll('.variant-option.selected').forEach(function(option) {
      // Extraire le type d'option du titre de section et normaliser
      let optionType = option.closest('.product-variants').querySelector('.option-section-title').textContent.toLowerCase().trim();
      
      // Normaliser les types d'options pour correspondre aux attributs data-option-type
      if (optionType.includes('moteur')) optionType = 'moteur';
      if (optionType.includes('batterie')) optionType = 'batterie';
      
      const optionValue = option.getAttribute('data-value');
      selectedOptions[optionType] = optionValue;
    });
    
    // S'assurer que les conteneurs d'overlay sont visibles s'il y a des options sélectionnées
    const desktopOverlayContainer = document.getElementById('overlay-container');
    const mobileOverlayContainer = document.getElementById('mobile-overlay-container');
    
    if (Object.keys(selectedOptions).length > 0) {
      // Rendre visible le conteneur desktop
      if (desktopOverlayContainer) {
        desktopOverlayContainer.classList.remove('hidden');
      }
      
      // S'assurer que le conteneur mobile est également visible
      if (mobileOverlayContainer) {
        mobileOverlayContainer.classList.remove('hidden');
      }
    }
    
    // Mettre à jour les images superposées pour les moteurs et batteries (version desktop et mobile)
    document.querySelectorAll('.engine-overlay, .battery-overlay').forEach(function(image) {
      const optionType = image.getAttribute('data-option-type');
      const optionValue = image.getAttribute('data-option-value');
      
      if (selectedOptions[optionType] === optionValue) {
        // Transition douce vers visible
        image.style.opacity = '1';
      } else {
        // Transition douce vers invisible
        image.style.opacity = '0';
      }
    });
    
    // Mettre à jour les images superposées pour les accessoires (version desktop et mobile)
    /* document.querySelectorAll('.accessory-overlay').forEach(function(image) {
      const productId = image.getAttribute('data-product-id');
      const checkbox = document.querySelector(`input[data-product-id="${productId}"].accessory-checkbox`);
      
      // Si l'accessoire correspondant est coché, afficher l'image
      if (checkbox && checkbox.checked) {
        // Transition douce vers visible
        image.style.opacity = '1';
      } else {
        // Transition douce vers invisible
        image.style.opacity = '0';
      }
    }); */
    
    // Synchroniser les images superposées entre la version desktop et mobile
    syncOverlayImages();
  }
  
  /**
   * Configuration des écouteurs d'événements pour les options de variante
   * Gère la sélection des options et met à jour l'interface en conséquence
   */
  function setupVariantOptionListeners() {
    elements.variantOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        const variantSection = this.closest('.product-variants');
        
        // Désélectionner toutes les options dans cette section
        variantSection.querySelectorAll('.variant-option').forEach(function(opt) {
          opt.classList.remove('selected');
        });
        
        // Sélectionner cette option
        this.classList.add('selected');
        
        // Mettre à jour le sélecteur de variante et le récapitulatif
        updateVariantSelector();
        updateSummary();
        
        // Mettre à jour les images superposées
        updateOverlayImages();
        
        // Calculer le prix exact via l'API Shopify
        calculateShopifyTotal();
      });
    });
  }
  
  // Initialiser les écouteurs d'événements pour les options de variante
  setupVariantOptionListeners();
  
  // Initialiser les images superposées au chargement de la page
  updateOverlayImages();
  

  
  /**
   * Synchronise les états des images superposées entre la version desktop et mobile
   */
  function syncOverlayImages() {
    // Synchroniser les images des moteurs
    document.querySelectorAll('#overlay-container .engine-overlay').forEach(function(desktopImage) {
      const optionType = desktopImage.getAttribute('data-option-type');
      const optionValue = desktopImage.getAttribute('data-option-value');
      const mobileImage = document.querySelector(`#mobile-overlay-container .engine-overlay[data-option-type="${optionType}"][data-option-value="${optionValue}"]`);
      
      if (mobileImage) {
        mobileImage.style.opacity = desktopImage.style.opacity;
      }
    });
    
    // Synchroniser les images des batteries
    document.querySelectorAll('#overlay-container .battery-overlay').forEach(function(desktopImage) {
      const optionType = desktopImage.getAttribute('data-option-type');
      const optionValue = desktopImage.getAttribute('data-option-value');
      const mobileImage = document.querySelector(`#mobile-overlay-container .battery-overlay[data-option-type="${optionType}"][data-option-value="${optionValue}"]`);
      
      if (mobileImage) {
        mobileImage.style.opacity = desktopImage.style.opacity;
      }
    });
    
    // Synchroniser les images des accessoires
    document.querySelectorAll('#overlay-container .accessory-overlay').forEach(function(desktopImage) {
      const productId = desktopImage.getAttribute('data-product-id');
      const mobileImage = document.querySelector(`#mobile-overlay-container .accessory-overlay[data-product-id="${productId}"]`);
      
      if (mobileImage) {
        mobileImage.style.opacity = desktopImage.style.opacity;
      }
    });
  }
  
  /**
   * Fonction principale pour mettre à jour le récapitulatif des choix et prix
   * Gère l'affichage des options sélectionnées et le calcul du prix total
   */
  function updateSummary() {
    if (!elements.summaryItems) {
      console.error('Élément summary-items non trouvé');
      return;
    }
    
    // Réinitialiser le récapitulatif
    elements.summaryItems.innerHTML = '';
    
    // Identifier les sections de variantes importantes
    const sections = findVariantSections();
    
    // Ajouter les options principales au récapitulatif
    const moteurInfo = addMoteurToSummary(sections.moteurSection);
    const batterieInfo = addBatterieToSummary(sections.batterieSection);
    
    // Mettre à jour la variante sélectionnée dans le sélecteur Shopify
    updateVariantSelector();
    
    // Calculer le prix total initial (moteur + batterie)
    let totalPrice = moteurInfo.price + batterieInfo.price;
    
    // Ajouter les accessoires sélectionnés au récapitulatif
    totalPrice += addAccessoriesToSummary();
    
    // Mettre à jour l'affichage des prix
    updatePriceDisplay(totalPrice);
  }
  
  /**
   * Trouve et identifie les sections de variantes importantes (moteur, batterie)
   * @returns {Object} Sections de variantes identifiées
   */
  function findVariantSections() {
    const variantSections = document.querySelectorAll('.product-variants');
    
    let moteurSection = null;
    let batterieSection = null;
    
    variantSections.forEach(section => {
      const title = section.querySelector('.option-section-title')?.textContent || '';
      
      if (title.toLowerCase().includes('moteur')) {
        moteurSection = section;
      } else if (title.toLowerCase().includes('batterie')) {
        batterieSection = section;
      }
    });
    
    return { moteurSection, batterieSection };
  }
  
  /**
   * Ajoute le moteur sélectionné au récapitulatif
   * @param {HTMLElement} moteurSection - Section contenant les options de moteur
   * @returns {Object} Informations sur le moteur sélectionné
   */
  function addMoteurToSummary(moteurSection) {
    let moteurTitle = 'Standard';
    let moteurPrice = 0;
    
    if (moteurSection) {
      let moteurSelected = moteurSection.querySelector('.variant-option.selected');
      
      if (!moteurSelected) {
        // Sélectionner le premier moteur par défaut s'il n'y en a pas de sélectionné
        moteurSelected = moteurSection.querySelector('.variant-option');
        if (moteurSelected) moteurSelected.classList.add('selected');
      }
      
      if (moteurSelected) {
        moteurTitle = moteurSelected.querySelector('.variant-option-title')?.textContent;
        const moteurPriceElement = moteurSelected.querySelector('.option-value-price');
        // Utiliser directement la valeur de l'attribut data-price
        moteurPrice = parseFloat(moteurPriceElement?.getAttribute('data-price')?.replace(',', '.') || 0);
        const moteurPriceText = moteurPriceElement?.textContent;
        
        const moteurItem = document.createElement('div');
        moteurItem.className = 'summary-item';
        
        const titleSpan = document.createElement('span');
        titleSpan.className = 'summary-item-title';
        titleSpan.textContent = `${moteurTitle}`;
        
        const priceSpan = document.createElement('span');
        priceSpan.className = 'summary-item-price';
        priceSpan.textContent = moteurPriceText;
        
        moteurItem.appendChild(titleSpan);
        moteurItem.appendChild(priceSpan);
        elements.summaryItems.appendChild(moteurItem);
      }
    }
    
    return { title: moteurTitle, price: moteurPrice };
  }
  
  /**
   * Ajoute la batterie sélectionnée au récapitulatif
   * @param {HTMLElement} batterieSection - Section contenant les options de batterie
   * @returns {Object} Informations sur la batterie sélectionnée
   */
  function addBatterieToSummary(batterieSection) {
    let batterieTitle = 'Standard';
    let batteriePrice = 0;
    
    if (batterieSection) {
      let batterieSelected = batterieSection.querySelector('.variant-option.selected');
      
      if (!batterieSelected) {
        // Sélectionner la première batterie par défaut s'il n'y en a pas de sélectionnée
        batterieSelected = batterieSection.querySelector('.variant-option');
        if (batterieSelected) batterieSelected.classList.add('selected');
      }
      
      if (batterieSelected) {
        batterieTitle = batterieSelected.querySelector('.variant-option-title')?.textContent;
        const batteriePriceElement = batterieSelected.querySelector('.option-value-price');
        // Utiliser directement la valeur de l'attribut data-price
        batteriePrice = parseFloat(batteriePriceElement?.getAttribute('data-price')?.replace(',', '.') || 0);
        const batteriePriceText = batteriePriceElement?.textContent;
        
        const batterieItem = document.createElement('div');
        batterieItem.className = 'summary-item';
        
        const titleSpan = document.createElement('span');
        titleSpan.className = 'summary-item-title';
        titleSpan.textContent = `${batterieTitle}`;
        
        const priceSpan = document.createElement('span');
        priceSpan.className = 'summary-item-price';
        priceSpan.textContent = batteriePriceText;
        
        batterieItem.appendChild(titleSpan);
        batterieItem.appendChild(priceSpan);
        elements.summaryItems.appendChild(batterieItem);
      }
    }
    
    return { title: batterieTitle, price: batteriePrice };
  }
  
  /**
   * Ajoute les accessoires sélectionnés au récapitulatif
   * @returns {number} Prix total des accessoires sélectionnés
   */
  function addAccessoriesToSummary() {
    let accessoriesTotal = 0;
    
    // Parcourir les accessoires dans l'ordre où ils ont été cochés
    accessoriesOrder.forEach(function(accessoryId) {
      // Trouver la case à cocher correspondante
      const checkbox = document.querySelector(`input[data-product-id="${accessoryId}"].accessory-checkbox`);
      
      if (checkbox && checkbox.checked) {
        const accessoryTitle = checkbox.dataset.productTitle;
        // Trouver l'élément parent pour pouvoir accéder au texte du prix
        const accessoryContainer = checkbox.closest('.accessory-item');
        // Récupérer le texte du prix directement depuis l'élément .variant-option-price
        const priceElement = accessoryContainer.querySelector('.variant-option-price');
        const accessoryPriceText = priceElement ? priceElement.textContent : '0,00';
        // Utiliser directement la valeur de l'attribut data-product-price pour les calculs
        const accessoryPrice = parseFloat(checkbox.dataset.productPrice.replace(',', '.') || 0);
        
        const accessoryItem = document.createElement('div');
        accessoryItem.className = 'summary-item';
        
        const titleSpan = document.createElement('span');
        titleSpan.className = 'summary-item-title';
        titleSpan.textContent = `+ ${accessoryTitle}`;
        
        const priceSpan = document.createElement('span');
        priceSpan.className = 'summary-item-price';
        priceSpan.textContent = accessoryPriceText;
        
        accessoryItem.appendChild(titleSpan);
        accessoryItem.appendChild(priceSpan);
        elements.summaryItems.appendChild(accessoryItem);
        
        accessoriesTotal += accessoryPrice;
      }
    });
    
    return accessoriesTotal;
  }
  
  /**
   * Met à jour l'affichage du prix total dans le récapitulatif et le bouton de paiement
   * @param {number} totalPrice - Prix total à afficher
   */
  function updatePriceDisplay(totalPrice) {
    // Formater le prix total (utiliser un espace normal au lieu d'un espace insécable)
    const formattedPrice = Number.isInteger(totalPrice) 
      ? totalPrice + " €" 
      : totalPrice.toFixed(2).replace('.', ',') + " €";

    // Afficher l'acompte réel calculé côté Shopify (déjà remisé)
    // Le paramètre 'totalPrice' doit être le montant déjà remisé (cartData.total_price)
    const formattedDeposit = Number.isInteger(totalPrice) 
      ? totalPrice + " €" 
      : totalPrice.toFixed(2).replace('.', ',') + " €";

    // Mettre à jour le prix total dans le récapitulatif principal
    if (elements.summaryTotalPrice) {
      elements.summaryTotalPrice.textContent = formattedPrice;
    }
    
    // Mettre à jour le prix total dans le récapitulatif mobile
    if (elements.mobileSummaryTotalPrice) {
      elements.mobileSummaryTotalPrice.textContent = formattedPrice;
    }
    
    // Mettre à jour l'acompte dans le récapitulatif principal
    const depositElement = document.querySelector('.summary-deposit-price');
    if (depositElement) {
      depositElement.textContent = formattedDeposit;
    }
    
    // Mettre à jour l'acompte dans le récapitulatif mobile
    const mobileDepositElement = document.querySelector('.mobile-summary-deposit-price');
    if (mobileDepositElement) {
      mobileDepositElement.textContent = formattedDeposit;
    }
    
    // Synchroniser le contenu du récapitulatif principal vers le récapitulatif mobile
    updateMobileSummary();
  }
  
  /**
   * Synchronise le contenu du récapitulatif principal vers le récapitulatif mobile
   */
  function updateMobileSummary() {
    if (!elements.mobileSummaryItems || !elements.summaryItems) {
      return;
    }
    
    // Vider le récapitulatif mobile
    elements.mobileSummaryItems.innerHTML = '';
    
    // Cloner tous les éléments du récapitulatif principal vers le récapitulatif mobile
    const summaryItems = elements.summaryItems.querySelectorAll('.summary-item');
    summaryItems.forEach(function(item) {
      const clonedItem = item.cloneNode(true);
      elements.mobileSummaryItems.appendChild(clonedItem);
    });
  }
  
  /**
   * Initialise le bouton de toggle pour afficher/masquer les détails du récapitulatif mobile
   */
  function initMobileSummaryToggle() {
    const toggleButton = document.querySelector('.mobile-summary-toggle');
    const detailsContainer = document.getElementById('mobile-summary-items');
    
    if (!toggleButton || !detailsContainer) {
      return;
    }
    
    toggleButton.addEventListener('click', function() {
      // Basculer la classe 'hidden' pour afficher/masquer les détails
      detailsContainer.classList.toggle('hidden');
      
      // Changer l'icône du bouton (+ ou -)
      const toggleIcon = toggleButton.querySelector('.toggle-icon');
      if (toggleIcon) {
        toggleIcon.textContent = detailsContainer.classList.contains('hidden') ? '+' : '-';
      }
    });
  }
  
  // Tableau pour stocker les IDs des accessoires cochés dans l'ordre
  let accessoriesOrder = [];
  
  /**
   * Configuration des écouteurs d'événements pour les accessoires
   */
  function setupAccessoryListeners() {
    elements.accessoryCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        const accessoryId = checkbox.dataset.productId;
        
        if (checkbox.checked) {
          // Si l'accessoire est coché, l'ajouter à la fin du tableau d'ordre
          if (!accessoriesOrder.includes(accessoryId)) {
            accessoriesOrder.push(accessoryId);
          }
          // Ajouter l'attribut checked pour la cohérence visuelle
          checkbox.setAttribute('checked', '');
        } else {
          // Si l'accessoire est décoché, le retirer du tableau d'ordre
          accessoriesOrder = accessoriesOrder.filter(id => id !== accessoryId);
          // Supprimer l'attribut checked
          checkbox.removeAttribute('checked');
        }
        
        updateSummary();
        updateOverlayImages(); // Mettre à jour les images superposées lorsqu'un accessoire est coché/décoché
        
        // Calculer le prix exact via l'API Shopify
        calculateShopifyTotal();
      });
    });
  }
  
  /**
   * Configuration du bouton d'achat
   * Gère l'ajout au panier et la redirection vers le checkout
   */
  function setupBuyNowButton() {
    if (elements.buyNowButton) {
      elements.buyNowButton.addEventListener('click', function(event) {
        event.preventDefault();
        addToCartAndCheckout();
      });
    }
  }
  
  /**
   * Vide la panier puis ajoute les produits sélectionnés au panier et redirige vers le checkout
   * en appliquant automatiquement le code de réduction ACOMPTE50
   */
  async function addToCartAndCheckout() {
    try {
      // Afficher un indicateur de chargement sur le bouton
      const button = document.querySelector('.payment-button');
      if (button) {
        const originalText = button.innerHTML;
        button.innerHTML = `
  <span class="payment-button-loader" style="display:flex;justify-content:center;align-items:center;width:100%;">
    <svg class="loader-spinner" width="28" height="28" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke="#fff" stroke-width="5" stroke-linecap="round"/>
    </svg>
  </span>
`;
        button.disabled = true;
      }
      
      // 1. Récupérer l'ID de la variante batterie/moteur
      const variantId = elements.variantInput?.value;
      if (!variantId) throw new Error('Aucune variante de produit sélectionnée');
      
      // 2. Préparer les données de la configuration
      const configuration = {
        mainVariant: {
          id: variantId,
          quantity: 1
        },
        accessories: []
      };

      // 3. Récupérer les ids de variantes des accessoires cochés
      document.querySelectorAll('.accessory-checkbox:checked').forEach(checkbox => {
        const accessoryVariantId = checkbox.getAttribute('data-variant-id');
        if (accessoryVariantId) {
          configuration.accessories.push({
            id: accessoryVariantId,
            quantity: 1
          });
        }
      });
      
      
      
      // 4. Vider le panier existant
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin'
      });
      
      if (!clearResponse.ok) {
        const clearError = await clearResponse.json();
        throw new Error(clearError.message || 'Échec du vidage du panier');
      }
      
      // 5. Préparer les items pour l'ajout au panier
      const items = [
        {
          id: configuration.mainVariant.id,
          quantity: configuration.mainVariant.quantity || 1
        },
        ...configuration.accessories.map(accessory => ({
          id: accessory.id,
          quantity: accessory.quantity || 1
        }))
      ];
      
      // 6. Ajouter les items au panier
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      
      const addResponseData = await addResponse.json();
      
      if (!addResponse.ok) {
        throw new Error(addResponseData.message || addResponseData.description || 'Échec de l\'ajout au panier');
      }
      
      window.location.href = '/checkout?discount=ACOMPTE50';

    } catch (error) {
      console.error('Erreur lors de la procédure de paiement:', error);
      alert('Une erreur est survenue lors de la procédure de paiement. Veuillez contacter le support.');
      
      // Rétablir le bouton en cas d'erreur
      const button = document.querySelector('.payment-button');
      if (button) {
        button.innerHTML = `<span class="payment-button-text">Commander</span><span class="payment-button-price">Acompte 50%</span>`; // Restaure le bouton à l'état normal
        button.disabled = false;
      }
    }
  }
  
  // Note: Nous ne réinitialisons plus les cases à cocher des accessoires au chargement
  // pour permettre aux utilisateurs de conserver leurs sélections
  
  // Initialiser les écouteurs d'événements pour les accessoires
  setupAccessoryListeners();
  
  // Initialiser le bouton d'achat
  setupBuyNowButton();
  // Initialiser l'état par défaut
  updateVariantSelector();
  updateSummary(); // Afficher les choix par défaut dès le chargement
  
  // Calculer le prix exact via l'API Shopify au chargement initial
  calculateShopifyTotal();
  
  /**
   * Initialise la sélection par défaut des variantes
   * Sélectionne la première option disponible si aucune n'est sélectionnée
   */
  function initializeDefaultSelection() {
    document.querySelectorAll('.product-variants').forEach(function(variantSection) {
      const selectedOption = variantSection.querySelector('.variant-option.selected');
      if (!selectedOption && variantSection.querySelector('.variant-option')) {
        variantSection.querySelector('.variant-option').click();
      }
    });
  }
  
  /**
   * Filtre les options selon les paramètres d'URL
   * Permet de pré-filtrer les options disponibles selon les paramètres transmis
   */
  function filterOptionsByUrlParams() {
    // Récupérer les paramètres d'URL
    const params = getUrlParameters();
    const urlParams = new URLSearchParams(window.location.search);
    
    // Vérifier si la configuration est disponible
    const hasValidEngines = params.moteurIds.length > 0;
    const hasValidBatteries = params.batterieIds.length > 0;
    const isConfigurationUnavailable = !hasValidEngines || !hasValidBatteries;
    
    if (isConfigurationUnavailable) {
      // CAS 1: Configuration indisponible
      // Afficher le message de configuration indisponible
      document.getElementById('configuration-unavailable').classList.remove('hidden');
      
      // Garder visible uniquement l'image principale du vélo (sans les overlays), le header et le message
      // Masquer tous les éléments de configuration
      document.querySelectorAll('#page-title-container, #overlay-container, .mobile-image-container, #product-variants-container, .accessory-options, .configuration-summary, .payment-button-container').forEach(element => {
        element.classList.add('hidden');
      });
      
    } else {
      // CAS 2: Configuration valide
      // Cacher le message de configuration indisponible
      document.getElementById('configuration-unavailable').classList.add('hidden');
      
      // Afficher tous les éléments de configuration
      document.querySelectorAll('#page-title-container, #overlay-container, .mobile-image-container, #product-variants-container, .accessory-options, .configuration-summary, .payment-button-container').forEach(element => {
        element.classList.remove('hidden');
      });
      
      // Filtrer les options de variantes et les accessoires
      filterVariantOptions(params);
      filterAccessories(params.accessoireIds);
      
      // Sélectionner les premières options visibles
      selectFirstVisibleOptions();
    }
  }
  
  /**
   * Récupère les paramètres d'URL pertinents pour le filtrage
   * @returns {Object} Paramètres d'URL pour le filtrage avec uniquement les IDs valides
   */
  function getUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Récupérer tous les IDs des options de moteur disponibles
    const availableMoteurIds = [];
    document.querySelectorAll('.product-variants').forEach(section => {
      if (section.querySelector('.option-section-title').textContent.trim() === 'Moteurs') {
        section.querySelectorAll('.variant-option').forEach(option => {
          const id = option.dataset.optionValueId;
          if (id) availableMoteurIds.push(id);
        });
      }
    });
    
    // Récupérer tous les IDs des options de batterie disponibles
    const availableBatterieIds = [];
    document.querySelectorAll('.product-variants').forEach(section => {
      if (section.querySelector('.option-section-title').textContent.trim() === 'Batteries') {
        section.querySelectorAll('.variant-option').forEach(option => {
          const id = option.dataset.optionValueId;
          if (id) availableBatterieIds.push(id);
        });
      }
    });
    
    // Récupérer tous les IDs des accessoires disponibles
    const availableAccessoireIds = [];
    document.querySelectorAll('.accessory-checkbox').forEach(checkbox => {
      const id = checkbox.dataset.productId;
      if (id) availableAccessoireIds.push(id);
    });
    
    // Filtrer les paramètres d'URL pour ne garder que les IDs valides
    const moteurIds = (urlParams.get('moteurs') || '').split(',').filter(id => id && availableMoteurIds.includes(id));
    const batterieIds = (urlParams.get('batteries') || '').split(',').filter(id => id && availableBatterieIds.includes(id));
    const accessoireIds = (urlParams.get('accessoires') || '').split(',').filter(id => id && availableAccessoireIds.includes(id));
    
    return { moteurIds, batterieIds, accessoireIds };
  }
  
  /**
   * Filtre les options de variantes selon les paramètres
   * @param {Object} params - Paramètres de filtrage
   */
  function filterVariantOptions(params) {

    document.querySelectorAll('.product-variants').forEach(variantSection => {
      const optionName = variantSection.querySelector('.option-section-title').textContent.trim();
      let optionIds = [];
      
      // Déterminer quels IDs utiliser selon le nom de l'option
      if (optionName === 'Moteurs') {
        optionIds = params.moteurIds;
      } else if (optionName === 'Batteries') {
        optionIds = params.batterieIds;
      }

      // Par défaut, toutes les options sont masquées (style="display: none;" dans le HTML)
      // On affiche uniquement celles qui sont dans les paramètres
      if (optionIds.length > 0) {
        let hasVisibleOption = false;
        
        variantSection.querySelectorAll('.variant-option').forEach(option => {
          // Récupérer l'ID de cette valeur d'option
          const optionId = option.dataset.optionValueId;
          
          // Si l'ID de la valeur d'option est dans la liste des IDs autorisés, l'afficher
          if (optionIds.includes(optionId)) {
            option.classList.remove('hidden');
            hasVisibleOption = true;
          }
        });

        // Si aucune option n'est visible, masquer toute la section
        if (!hasVisibleOption) {
          variantSection.classList.add('hidden');
        } else {
          variantSection.classList.remove('hidden');
        }
      }
    });
  }
  
  /**
   * Filtre les accessoires selon les IDs spécifiés
   * @param {Array} accessoireIds - IDs des accessoires à afficher
   */
  function filterAccessories(accessoireIds) {
    // Par défaut, tous les accessoires sont masqués (style="display: none;" dans le HTML)
    if (accessoireIds.length > 0) {
      document.querySelectorAll('.accessory-item').forEach(item => {
        const checkbox = item.querySelector('.accessory-checkbox');
        const productId = checkbox.dataset.productId;
        
        // Si l'ID de l'accessoire est dans la liste des IDs autorisés, l'afficher
        if (accessoireIds.includes(productId)) {
          item.classList.remove('hidden');
        }
      });
    }
    else {
      // enlever le hidden du message
      document.querySelector('.no-accessories-message').classList.remove('hidden');
    }
  }
  
  /**
   * Sélectionne automatiquement la première option visible pour les moteurs et batteries
   */
  function selectFirstVisibleOptions() {
    document.querySelectorAll('.product-variants').forEach(variantSection => {
      const optionName = variantSection.querySelector('.option-section-title').textContent.trim().toLowerCase();
      
      // Ne sélectionner automatiquement que pour les moteurs et batteries (singulier ou pluriel)
      if (optionName === 'moteur' || optionName === 'moteurs' || optionName === 'batterie' || optionName === 'batteries') {
        const firstVisibleOption = variantSection.querySelector('.variant-option:not(.hidden)');
        if (firstVisibleOption) {
          // Au lieu de simplement ajouter la classe, simuler un clic sur l'option
          // Cela déclenchera tous les événements associés et mettra à jour l'interface correctement
          firstVisibleOption.click();
        }
      }
    });
  }
  
  /**
   * Initialise l'accordéon pour les sections de configuration
   */
  function initAccordion() {
    const accordionHeaders = document.querySelectorAll('.accordion-header');
    const allSections = document.querySelectorAll('.accordion-section');
    
    // Configuration initiale : respecter l'état HTML, s'assurer que "Moteurs" est ouvert au besoin
    setupInitialAccordionState(allSections);
    
    // Ajouter des écouteurs d'événements aux en-têtes d'accordéon
    setupAccordionListeners(accordionHeaders, allSections);
  }
  
  /**
   * Configure l'état initial de l'accordéon
   * @param {NodeList} allSections - Toutes les sections de l'accordéon
   */
  function setupInitialAccordionState(allSections) {
    allSections.forEach(section => {
      const title = section.querySelector('.accordion-header')?.textContent?.trim() || '';
      if (title === 'Moteurs') {
        // Ouvrir Moteurs si présent, sans fermer les autres
        section.classList.add('active');
        const content = section.querySelector('.accordion-content');
        if (content) content.classList.add('active');
      }
      // Ne pas modifier les autres sections: on respecte l'état HTML
    });
  }
  
  /**
   * Configure les écouteurs d'événements pour l'accordéon
   * @param {NodeList} accordionHeaders - En-têtes de l'accordéon
   * @param {NodeList} allSections - Toutes les sections (non utilisé ici mais conservé pour compatibilité)
   */
  function setupAccordionListeners(accordionHeaders, allSections) {
    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        // Basculer uniquement la section actuelle sans fermer les autres
        const section = this.parentElement;
        section.classList.toggle('active');
        const content = section.querySelector('.accordion-content');
        if (content) content.classList.toggle('active');
      });
    });
  }
  
  // Initialiser le tableau des variantes sélectionnées (moteur, batterie, accessoires)
  window.selectedVariants = [];
  
  // Initialiser la sélection par défaut
  initializeDefaultSelection();
  
  // Exécuter le filtrage selon les paramètres d'URL
  filterOptionsByUrlParams();
  
  // Mettre à jour le tableau des sélections (accessoires uniquement)
  function updateSelectedItems() {
    // Réinitialiser le tableau
    window.selectedVariants = [];
    
    // Note: Nous ne stockons plus la variante principale (moteur + batterie) dans ce tableau
    // car elle est ajoutée séparément dans la fonction addToCartAndCheckout
    // Cela évite d'ajouter deux fois le même produit au panier
    
    // Ajouter les accessoires sélectionnés
    document.querySelectorAll('.accessory-checkbox:checked').forEach(checkbox => {
      if (checkbox.dataset.productId) {
        // Pour les accessoires, nous devons utiliser l'ID de la première variante du produit
        // car l'ID du produit seul ne fonctionne pas avec l'API cart/add.js
        const productId = checkbox.dataset.productId;
        
        // Créer un élément temporaire pour stocker l'ID de variante
        // Note: Cette approche suppose que chaque accessoire a une seule variante
        // Si ce n'est pas le cas, nous devrons modifier cette logique
        const variantId = checkbox.dataset.variantId || productId;
        
        window.selectedVariants.push({
          id: variantId,
          quantity: 1,
        });
      }
    });
    
  }
  
  // Écouter les changements sur les sélections de moteur, batterie et accessoires
  document.addEventListener('change', function(e) {
    // Vérifier si le changement concerne un élément à suivre
    const target = e.target;
    if (target.matches('.accessory-checkbox, .option-section[data-type="moteur"] input[type="radio"], .option-section[data-type="batterie"] input[type="radio"]')) {
      updateSelectedItems();
    }
  });
  
  // Mettre à jour la sélection initiale
  updateSelectedItems();
  
  /**
   * Formate un montant en centimes en une chaîne de caractères avec le symbole €
   * @param {number} cents - Montant en centimes
   * @returns {string} Montant formaté (ex: "1 234,56 €")
   */
  function formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    }).format(amount);
  }
  
  /**
   * Affiche les loaders de prix pendant le calcul
   */
  function showPriceLoaders() {
    // Version desktop
    document.querySelectorAll('.price-loader, .deposit-loader').forEach(loader => {
      loader.classList.remove('hidden');
    });
    document.querySelectorAll('.summary-total-price, .summary-deposit-price').forEach(value => {
      value.classList.add('hidden');
    });
    
    // Version mobile
    document.querySelectorAll('.mobile-price-loader, .mobile-deposit-loader').forEach(loader => {
      loader.classList.remove('hidden');
    });
    document.querySelectorAll('.mobile-summary-total-price, .mobile-summary-deposit-price').forEach(value => {
      value.classList.add('hidden');
    });
  }
  
  /**
   * Masque les loaders de prix après le calcul
   */
  function hidePriceLoaders() {
    // Version desktop
    document.querySelectorAll('.price-loader, .deposit-loader').forEach(loader => {
      loader.classList.add('hidden');
    });
    document.querySelectorAll('.summary-total-price, .summary-deposit-price').forEach(value => {
      value.classList.remove('hidden');
    });
    
    // Version mobile
    document.querySelectorAll('.mobile-price-loader, .mobile-deposit-loader').forEach(loader => {
      loader.classList.add('hidden');
    });
    document.querySelectorAll('.mobile-summary-total-price, .mobile-summary-deposit-price').forEach(value => {
      value.classList.remove('hidden');
    });
  }
  
  /**
   * Calcule le total exact via l'API Cart de Shopify
   * Cette fonction fait une requête à l'API Cart pour obtenir le prix exact calculé par Shopify
   * incluant l'application du code de réduction ACOMPTE50
   */
  async function calculateShopifyTotal() {
    try {
      // Afficher les loaders
      showPriceLoaders();
      
      // Récupérer l'ID de la variante principale (moteur/batterie)
      const variantId = elements.variantInput?.value;
      if (!variantId) {
        console.warn("Impossible de calculer le total Shopify: ID de variante non disponible");
        hidePriceLoaders();
        return;
      }
      
      // Récupérer les IDs des accessoires sélectionnés
      const accessoryItems = [];
      document.querySelectorAll('.accessory-checkbox:checked').forEach(checkbox => {
        // Utiliser l'ID de variante stocké dans l'attribut data-variant-id
        const accessoryVariantId = checkbox.getAttribute('data-variant-id') || checkbox.value;
        accessoryItems.push({
          id: accessoryVariantId,
          quantity: 1
        });
      });
      
      // Préparer les items pour la requête
      const items = [
        {
          id: variantId,
          quantity: 1
        },
        ...accessoryItems
      ];
      
      
      // 1. Vider le panier actuel
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      // 2. Ajouter les items au panier pour le calcul
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      
      if (!addResponse.ok) {
        throw new Error('Erreur lors de l\'ajout au panier pour calcul');
      }
      
      // 3. Appliquer le code de réduction ACOMPTE50 via /cart/update.js (méthode officielle Shopify)
      const discountResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: 'ACOMPTE50' })
      });
      if (!discountResponse.ok) {
        console.warn("Le code de réduction ACOMPTE50 n'a pas pu être appliqué (Shopify)");
      }
      
      // 4. Récupérer les informations du panier avec la réduction appliquée
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      
      if (cartData.total_price !== undefined) {
        // Formater le prix total calculé par Shopify
        const formattedTotalPrice = formatMoney(cartData.total_price);
        const formattedOriginalPrice = formatMoney(cartData.original_total_price || cartData.items_subtotal_price);
        
        // Mettre à jour l'affichage avec le prix calculé par Shopify - Version desktop
        const priceValueElement = document.querySelector('.summary-total-price');
        if (priceValueElement) {
          priceValueElement.textContent = formattedOriginalPrice;
        }
        
        const depositValueElement = document.querySelector('.summary-deposit-price');
        if (depositValueElement) {
          depositValueElement.textContent = formattedTotalPrice;
        }
        
        // Mettre à jour l'affichage avec le prix calculé par Shopify - Version mobile
        const mobilePriceValueElement = document.querySelector('.mobile-summary-total-price');
        if (mobilePriceValueElement) {
          mobilePriceValueElement.textContent = formattedOriginalPrice;
        }
        
        const mobileDepositValueElement = document.querySelector('.mobile-summary-deposit-price');
        if (mobileDepositValueElement) {
          mobileDepositValueElement.textContent = formattedTotalPrice;
        }
      }
      
      // 5. Vider le panier après le calcul
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      // Masquer les loaders une fois le calcul terminé
      hidePriceLoaders();
      
    } catch (error) {
      console.error('Erreur lors du calcul du total via Shopify:', error);
      // Masquer les loaders en cas d'erreur
      hidePriceLoaders();
    }
  }
});
